import React, { useEffect, useState } from "react";
import { getViewImageHotel, UpdateImageDetails, updateImageStatus } from "../../../utils/api";
import { Link, useParams } from "react-router-dom";
import { Modal } from "antd";
import { ModalPopUp } from "../../../Components/ModalPopUp/ModalPopUp";
import "./ViewHotelImageDetails.css";
import { AlertWrapper } from "../../../assets/styles/AlerWrapper";
import { isEmpty } from "../../../utils/common";

const ViewHotelImageDetails = ({ setShowAddImage, hotelCode }) => {
  const { id } = useParams();
  const [viewHotelData, setViewHotelData] = useState([]);
  const [popupData, setPopupData] = useState(false);
  const [actualSizePopup, setActualSizePopup] = useState(null);
  const [message,setMesaage] = useState("");
  

  const viewHotel = () => {
    const param = { hotelCode: hotelCode };

    getViewImageHotel(param)
      .then((response) => {
        setViewHotelData(response?.data?.data?.hotelImages.content || []);
      })
      .catch((error) => {
        console.error("Error fetching hotel images:", error);
      });
  };

  useEffect(() => {
    viewHotel();
  }, []);

  const groupedImages = viewHotelData.reduce((acc, item) => {
    
    const category = item.category || "Default"; 
    const subCategory = item.subCategory || "Default";
    acc[category] = acc[category] || {};
    acc[category][subCategory] = acc[category][subCategory] || [];
    acc[category][subCategory].push(item);
    return acc;
  }, {});

  const handleEditIconClick = (image) => {
    setPopupData({
      id: image.id,
      category: image.category,
      subCategory: image.subCategory,
    });
  };

  const handleInputChange = (field, value) => {
    setPopupData((prev) => ({ ...prev, [field]: value }));
  };

  const handleUpdateImage = () => {
    const formData = new FormData();
    const request = {
      id: popupData.id,
      category: popupData.category,
      subCategory: popupData.subCategory,
    };

    formData.append("request", JSON.stringify(request));

    UpdateImageDetails(formData)
      .then((response) => {
        console.log("Update success", response);
        setMesaage({type:"success",message:"Updated succesfully"});
        setPopupData(null);
        viewHotel();
      })
      .catch((error) => {
        setMesaage({type:"error",message:"Failed"});

        console.error("Error updating image:", error);
      });
  };

  const updateStatus = (id, index) => {
    updateImageStatus(id)
      .then((resp) => {
        if (resp.status === 200) {
          const statusUpdate = resp?.data?.data || {};
          const status = JSON.parse(JSON.stringify(viewHotelData));
          status[index] = statusUpdate;
          setViewHotelData([...status]);

          setMesaage({ type: "success", message: "Status Updated successfully" });
        }
      })
      .catch((error) => {
        console.error("Error updating status:", error);
        setMesaage({ type: "error", message: "Failed to update" });
      });  };

  const handleShowActualSize = (category) => {
    setActualSizePopup(category);
  };

   useEffect(() =>{
     if( isEmpty(message)) return;
    
     setTimeout(() =>{
      setMesaage({})
     },5000)
    
      },[message])
  
  return (
    <div>
 {!isEmpty(message) && (
                         <AlertWrapper className={`${message.type} globle`}>
                           <span className="close" onClick={() => setMesaage({})}>
                             ×
                           </span>
                           {message.message}
                         </AlertWrapper>
                       )}

      {Object.entries(groupedImages).map(([category, subCategories]) => (
        <div key={category} className="category-section">
          <h3 className="flex align-item gap-10">
            {`Category: ${category}`}
            <Link
              className="fs-14"
              onClick={() => handleShowActualSize(category)}
            >
              Show Actual Size
            </Link>
          </h3>

          {Object.entries(subCategories).map(([subCategory, images]) => (
            <div key={subCategory} className="subcategory-section">
              <h4>{`Subcategory: ${subCategory}`}</h4>

              <div className="image-grid">
                {images.map((image, index) => (
                  <div key={index} className="image-grid-item">
                    <img
                      src={`https://travelbookings.s3.ap-south-1.amazonaws.com/${image.imageSlug}`}
                      alt={`${category} - ${subCategory}`}
                      className="image"
                    />
                    <div className="image-actions">
                      <button
                        className="edit-icon-btn"
                        onClick={() => handleEditIconClick(image)}
                      >
                        <i className="fa-solid fa-pen-to-square" style={{ color: "#fff" }}></i>
                      </button>

                      <button
                        className="eye-icon-btn"
                        onClick={() => updateStatus(image.id, index)}
                      >
                        {image.active ? (
                          <i className="fa-solid fa-eye open-eye"></i>
                        ) : (
                          <i className="fa-solid fa-eye-slash closed-eye" style={{ color: "#fff" }}></i>
                        )}
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      ))}

      {popupData && (
        <ModalPopUp>
          <div className="modal-popup">
            <div className="popup-content">
               
                 


              <h3>Edit Image Details</h3>
              <div className= "mt-10">
                <div className="text-start">
                <label className="fw-bold mb-5">
                  CATEGORY:
                  </label>
                </div>
                
                <input
                    style={{flex:"1 1 50%",width:"100%"}}
                    type="text"
                    value={popupData.category}
                    onChange={(e) => handleInputChange("category", e.target.value)}
                  />
              </div>
              <div className=" mt-10">
                <div className="text-start">
                <label className="fw-bold mb-5">
                  SUBCATGORY:
                  
                </label>
                </div>
               
                <input
                  style={{flex:"1 1 50%",width:"100%"}}
                    type="text"
                    value={popupData.subCategory}
                    onChange={(e) => handleInputChange("subCategory", e.target.value)}
                  />
              </div>
              <div className="popup-buttons  flex gap-10 mt-20 ">
                <button className="userlist_btn" onClick={handleUpdateImage}>UPDATE</button>
                <button className="userlist_btn" onClick={() => setPopupData(null)}>CANCLE</button>
              </div>
            </div>
            
          </div>
        </ModalPopUp>
      )}

      {actualSizePopup && (
        <Modal visible onCancel={() => setActualSizePopup(null)} footer={null}>
          <div className="actual-size-popup">
            <h3>{`Images in Category: ${actualSizePopup}`}</h3>
            <div className="actual-size-image-grid">
              {Object.values(groupedImages[actualSizePopup]).flat().map((image, index) => (
                <img
                  key={index}
                  src={`https://travelbookings.s3.ap-south-1.amazonaws.com/${image.imageSlug}`}
                  alt={actualSizePopup}
                  className="actual-size-image"
                />
              ))}
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
};

export default ViewHotelImageDetails;
